module.exports = __webpack_public_path__ + "static/media/454A9096.36f3cdd8.jpg";